/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as PublicIndexRouteImport } from './routes/_public.index'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as AdminAuthedRouteImport } from './routes/admin._authed'
import { Route as PublicTeamRouteImport } from './routes/_public.team'
import { Route as PublicServicesRouteImport } from './routes/_public.services'
import { Route as PublicPortfolioRouteImport } from './routes/_public.portfolio'
import { Route as PublicContactRouteImport } from './routes/_public.contact'
import { Route as PublicAboutRouteImport } from './routes/_public.about'
import { Route as PublicSlugRouteImport } from './routes/_public.$slug'
import { Route as AdminAuthedIndexRouteImport } from './routes/admin._authed.index'
import { Route as PublicProductsIndexRouteImport } from './routes/_public.products.index'
import { Route as PublicBlogIndexRouteImport } from './routes/_public.blog.index'
import { Route as AdminAuthedUsersRouteImport } from './routes/admin._authed.users'
import { Route as AdminAuthedTestimonialsRouteImport } from './routes/admin._authed.testimonials'
import { Route as AdminAuthedTechnologiesRouteImport } from './routes/admin._authed.technologies'
import { Route as AdminAuthedTeamRouteImport } from './routes/admin._authed.team'
import { Route as AdminAuthedStatsRouteImport } from './routes/admin._authed.stats'
import { Route as AdminAuthedSettingsRouteImport } from './routes/admin._authed.settings'
import { Route as AdminAuthedServicesRouteImport } from './routes/admin._authed.services'
import { Route as AdminAuthedProfileRouteImport } from './routes/admin._authed.profile'
import { Route as AdminAuthedProductsRouteImport } from './routes/admin._authed.products'
import { Route as AdminAuthedPortfolioRouteImport } from './routes/admin._authed.portfolio'
import { Route as AdminAuthedPagesRouteImport } from './routes/admin._authed.pages'
import { Route as AdminAuthedMessagesRouteImport } from './routes/admin._authed.messages'
import { Route as AdminAuthedMenuRouteImport } from './routes/admin._authed.menu'
import { Route as AdminAuthedDashboardRouteImport } from './routes/admin._authed.dashboard'
import { Route as AdminAuthedCompanyValuesRouteImport } from './routes/admin._authed.company-values'
import { Route as PublicProductsSlugRouteImport } from './routes/_public.products.$slug'
import { Route as PublicBlogSlugRouteImport } from './routes/_public.blog.$slug'
import { Route as AdminAuthedBlogIndexRouteImport } from './routes/admin._authed.blog.index'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/admin/login',
  path: '/admin/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuthedRoute = AdminAuthedRouteImport.update({
  id: '/admin/_authed',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicTeamRoute = PublicTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => PublicRoute,
} as any)
const PublicServicesRoute = PublicServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => PublicRoute,
} as any)
const PublicPortfolioRoute = PublicPortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => PublicRoute,
} as any)
const PublicContactRoute = PublicContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAboutRoute = PublicAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSlugRoute = PublicSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => PublicRoute,
} as any)
const AdminAuthedIndexRoute = AdminAuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminAuthedRoute,
} as any)
const PublicProductsIndexRoute = PublicProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicBlogIndexRoute = PublicBlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => PublicRoute,
} as any)
const AdminAuthedUsersRoute = AdminAuthedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminAuthedRoute,
} as any)
const AdminAuthedTestimonialsRoute = AdminAuthedTestimonialsRouteImport.update({
  id: '/testimonials',
  path: '/testimonials',
  getParentRoute: () => AdminAuthedRoute,
} as any)
const AdminAuthedTechnologiesRoute = AdminAuthedTechnologiesRouteImport.update({
  id: '/technologies',
  path: '/technologies',
  getParentRoute: () => AdminAuthedRoute,
} as any)
const AdminAuthedTeamRoute = AdminAuthedTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AdminAuthedRoute,
} as any)
const AdminAuthedStatsRoute = AdminAuthedStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => AdminAuthedRoute,
} as any)
const AdminAuthedSettingsRoute = AdminAuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminAuthedRoute,
} as any)
const AdminAuthedServicesRoute = AdminAuthedServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => AdminAuthedRoute,
} as any)
const AdminAuthedProfileRoute = AdminAuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AdminAuthedRoute,
} as any)
const AdminAuthedProductsRoute = AdminAuthedProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AdminAuthedRoute,
} as any)
const AdminAuthedPortfolioRoute = AdminAuthedPortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => AdminAuthedRoute,
} as any)
const AdminAuthedPagesRoute = AdminAuthedPagesRouteImport.update({
  id: '/pages',
  path: '/pages',
  getParentRoute: () => AdminAuthedRoute,
} as any)
const AdminAuthedMessagesRoute = AdminAuthedMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AdminAuthedRoute,
} as any)
const AdminAuthedMenuRoute = AdminAuthedMenuRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => AdminAuthedRoute,
} as any)
const AdminAuthedDashboardRoute = AdminAuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminAuthedRoute,
} as any)
const AdminAuthedCompanyValuesRoute =
  AdminAuthedCompanyValuesRouteImport.update({
    id: '/company-values',
    path: '/company-values',
    getParentRoute: () => AdminAuthedRoute,
  } as any)
const PublicProductsSlugRoute = PublicProductsSlugRouteImport.update({
  id: '/products/$slug',
  path: '/products/$slug',
  getParentRoute: () => PublicRoute,
} as any)
const PublicBlogSlugRoute = PublicBlogSlugRouteImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => PublicRoute,
} as any)
const AdminAuthedBlogIndexRoute = AdminAuthedBlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => AdminAuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof PublicIndexRoute
  '/$slug': typeof PublicSlugRoute
  '/about': typeof PublicAboutRoute
  '/contact': typeof PublicContactRoute
  '/portfolio': typeof PublicPortfolioRoute
  '/services': typeof PublicServicesRoute
  '/team': typeof PublicTeamRoute
  '/admin': typeof AdminAuthedRouteWithChildren
  '/admin/login': typeof AdminLoginRoute
  '/blog/$slug': typeof PublicBlogSlugRoute
  '/products/$slug': typeof PublicProductsSlugRoute
  '/admin/company-values': typeof AdminAuthedCompanyValuesRoute
  '/admin/dashboard': typeof AdminAuthedDashboardRoute
  '/admin/menu': typeof AdminAuthedMenuRoute
  '/admin/messages': typeof AdminAuthedMessagesRoute
  '/admin/pages': typeof AdminAuthedPagesRoute
  '/admin/portfolio': typeof AdminAuthedPortfolioRoute
  '/admin/products': typeof AdminAuthedProductsRoute
  '/admin/profile': typeof AdminAuthedProfileRoute
  '/admin/services': typeof AdminAuthedServicesRoute
  '/admin/settings': typeof AdminAuthedSettingsRoute
  '/admin/stats': typeof AdminAuthedStatsRoute
  '/admin/team': typeof AdminAuthedTeamRoute
  '/admin/technologies': typeof AdminAuthedTechnologiesRoute
  '/admin/testimonials': typeof AdminAuthedTestimonialsRoute
  '/admin/users': typeof AdminAuthedUsersRoute
  '/blog/': typeof PublicBlogIndexRoute
  '/products/': typeof PublicProductsIndexRoute
  '/admin/': typeof AdminAuthedIndexRoute
  '/admin/blog/': typeof AdminAuthedBlogIndexRoute
}
export interface FileRoutesByTo {
  '/$slug': typeof PublicSlugRoute
  '/about': typeof PublicAboutRoute
  '/contact': typeof PublicContactRoute
  '/portfolio': typeof PublicPortfolioRoute
  '/services': typeof PublicServicesRoute
  '/team': typeof PublicTeamRoute
  '/admin/login': typeof AdminLoginRoute
  '/': typeof PublicIndexRoute
  '/blog/$slug': typeof PublicBlogSlugRoute
  '/products/$slug': typeof PublicProductsSlugRoute
  '/admin/company-values': typeof AdminAuthedCompanyValuesRoute
  '/admin/dashboard': typeof AdminAuthedDashboardRoute
  '/admin/menu': typeof AdminAuthedMenuRoute
  '/admin/messages': typeof AdminAuthedMessagesRoute
  '/admin/pages': typeof AdminAuthedPagesRoute
  '/admin/portfolio': typeof AdminAuthedPortfolioRoute
  '/admin/products': typeof AdminAuthedProductsRoute
  '/admin/profile': typeof AdminAuthedProfileRoute
  '/admin/services': typeof AdminAuthedServicesRoute
  '/admin/settings': typeof AdminAuthedSettingsRoute
  '/admin/stats': typeof AdminAuthedStatsRoute
  '/admin/team': typeof AdminAuthedTeamRoute
  '/admin/technologies': typeof AdminAuthedTechnologiesRoute
  '/admin/testimonials': typeof AdminAuthedTestimonialsRoute
  '/admin/users': typeof AdminAuthedUsersRoute
  '/blog': typeof PublicBlogIndexRoute
  '/products': typeof PublicProductsIndexRoute
  '/admin': typeof AdminAuthedIndexRoute
  '/admin/blog': typeof AdminAuthedBlogIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_public': typeof PublicRouteWithChildren
  '/_public/$slug': typeof PublicSlugRoute
  '/_public/about': typeof PublicAboutRoute
  '/_public/contact': typeof PublicContactRoute
  '/_public/portfolio': typeof PublicPortfolioRoute
  '/_public/services': typeof PublicServicesRoute
  '/_public/team': typeof PublicTeamRoute
  '/admin/_authed': typeof AdminAuthedRouteWithChildren
  '/admin/login': typeof AdminLoginRoute
  '/_public/': typeof PublicIndexRoute
  '/_public/blog/$slug': typeof PublicBlogSlugRoute
  '/_public/products/$slug': typeof PublicProductsSlugRoute
  '/admin/_authed/company-values': typeof AdminAuthedCompanyValuesRoute
  '/admin/_authed/dashboard': typeof AdminAuthedDashboardRoute
  '/admin/_authed/menu': typeof AdminAuthedMenuRoute
  '/admin/_authed/messages': typeof AdminAuthedMessagesRoute
  '/admin/_authed/pages': typeof AdminAuthedPagesRoute
  '/admin/_authed/portfolio': typeof AdminAuthedPortfolioRoute
  '/admin/_authed/products': typeof AdminAuthedProductsRoute
  '/admin/_authed/profile': typeof AdminAuthedProfileRoute
  '/admin/_authed/services': typeof AdminAuthedServicesRoute
  '/admin/_authed/settings': typeof AdminAuthedSettingsRoute
  '/admin/_authed/stats': typeof AdminAuthedStatsRoute
  '/admin/_authed/team': typeof AdminAuthedTeamRoute
  '/admin/_authed/technologies': typeof AdminAuthedTechnologiesRoute
  '/admin/_authed/testimonials': typeof AdminAuthedTestimonialsRoute
  '/admin/_authed/users': typeof AdminAuthedUsersRoute
  '/_public/blog/': typeof PublicBlogIndexRoute
  '/_public/products/': typeof PublicProductsIndexRoute
  '/admin/_authed/': typeof AdminAuthedIndexRoute
  '/admin/_authed/blog/': typeof AdminAuthedBlogIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$slug'
    | '/about'
    | '/contact'
    | '/portfolio'
    | '/services'
    | '/team'
    | '/admin'
    | '/admin/login'
    | '/blog/$slug'
    | '/products/$slug'
    | '/admin/company-values'
    | '/admin/dashboard'
    | '/admin/menu'
    | '/admin/messages'
    | '/admin/pages'
    | '/admin/portfolio'
    | '/admin/products'
    | '/admin/profile'
    | '/admin/services'
    | '/admin/settings'
    | '/admin/stats'
    | '/admin/team'
    | '/admin/technologies'
    | '/admin/testimonials'
    | '/admin/users'
    | '/blog/'
    | '/products/'
    | '/admin/'
    | '/admin/blog/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$slug'
    | '/about'
    | '/contact'
    | '/portfolio'
    | '/services'
    | '/team'
    | '/admin/login'
    | '/'
    | '/blog/$slug'
    | '/products/$slug'
    | '/admin/company-values'
    | '/admin/dashboard'
    | '/admin/menu'
    | '/admin/messages'
    | '/admin/pages'
    | '/admin/portfolio'
    | '/admin/products'
    | '/admin/profile'
    | '/admin/services'
    | '/admin/settings'
    | '/admin/stats'
    | '/admin/team'
    | '/admin/technologies'
    | '/admin/testimonials'
    | '/admin/users'
    | '/blog'
    | '/products'
    | '/admin'
    | '/admin/blog'
  id:
    | '__root__'
    | '/_public'
    | '/_public/$slug'
    | '/_public/about'
    | '/_public/contact'
    | '/_public/portfolio'
    | '/_public/services'
    | '/_public/team'
    | '/admin/_authed'
    | '/admin/login'
    | '/_public/'
    | '/_public/blog/$slug'
    | '/_public/products/$slug'
    | '/admin/_authed/company-values'
    | '/admin/_authed/dashboard'
    | '/admin/_authed/menu'
    | '/admin/_authed/messages'
    | '/admin/_authed/pages'
    | '/admin/_authed/portfolio'
    | '/admin/_authed/products'
    | '/admin/_authed/profile'
    | '/admin/_authed/services'
    | '/admin/_authed/settings'
    | '/admin/_authed/stats'
    | '/admin/_authed/team'
    | '/admin/_authed/technologies'
    | '/admin/_authed/testimonials'
    | '/admin/_authed/users'
    | '/_public/blog/'
    | '/_public/products/'
    | '/admin/_authed/'
    | '/admin/_authed/blog/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PublicRoute: typeof PublicRouteWithChildren
  AdminAuthedRoute: typeof AdminAuthedRouteWithChildren
  AdminLoginRoute: typeof AdminLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/admin/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/_authed': {
      id: '/admin/_authed'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminAuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/team': {
      id: '/_public/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof PublicTeamRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/services': {
      id: '/_public/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof PublicServicesRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/portfolio': {
      id: '/_public/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof PublicPortfolioRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/contact': {
      id: '/_public/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof PublicContactRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/about': {
      id: '/_public/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof PublicAboutRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/$slug': {
      id: '/_public/$slug'
      path: '/$slug'
      fullPath: '/$slug'
      preLoaderRoute: typeof PublicSlugRouteImport
      parentRoute: typeof PublicRoute
    }
    '/admin/_authed/': {
      id: '/admin/_authed/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminAuthedIndexRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
    '/_public/products/': {
      id: '/_public/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof PublicProductsIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/blog/': {
      id: '/_public/blog/'
      path: '/blog'
      fullPath: '/blog/'
      preLoaderRoute: typeof PublicBlogIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/admin/_authed/users': {
      id: '/admin/_authed/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminAuthedUsersRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
    '/admin/_authed/testimonials': {
      id: '/admin/_authed/testimonials'
      path: '/testimonials'
      fullPath: '/admin/testimonials'
      preLoaderRoute: typeof AdminAuthedTestimonialsRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
    '/admin/_authed/technologies': {
      id: '/admin/_authed/technologies'
      path: '/technologies'
      fullPath: '/admin/technologies'
      preLoaderRoute: typeof AdminAuthedTechnologiesRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
    '/admin/_authed/team': {
      id: '/admin/_authed/team'
      path: '/team'
      fullPath: '/admin/team'
      preLoaderRoute: typeof AdminAuthedTeamRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
    '/admin/_authed/stats': {
      id: '/admin/_authed/stats'
      path: '/stats'
      fullPath: '/admin/stats'
      preLoaderRoute: typeof AdminAuthedStatsRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
    '/admin/_authed/settings': {
      id: '/admin/_authed/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminAuthedSettingsRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
    '/admin/_authed/services': {
      id: '/admin/_authed/services'
      path: '/services'
      fullPath: '/admin/services'
      preLoaderRoute: typeof AdminAuthedServicesRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
    '/admin/_authed/profile': {
      id: '/admin/_authed/profile'
      path: '/profile'
      fullPath: '/admin/profile'
      preLoaderRoute: typeof AdminAuthedProfileRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
    '/admin/_authed/products': {
      id: '/admin/_authed/products'
      path: '/products'
      fullPath: '/admin/products'
      preLoaderRoute: typeof AdminAuthedProductsRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
    '/admin/_authed/portfolio': {
      id: '/admin/_authed/portfolio'
      path: '/portfolio'
      fullPath: '/admin/portfolio'
      preLoaderRoute: typeof AdminAuthedPortfolioRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
    '/admin/_authed/pages': {
      id: '/admin/_authed/pages'
      path: '/pages'
      fullPath: '/admin/pages'
      preLoaderRoute: typeof AdminAuthedPagesRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
    '/admin/_authed/messages': {
      id: '/admin/_authed/messages'
      path: '/messages'
      fullPath: '/admin/messages'
      preLoaderRoute: typeof AdminAuthedMessagesRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
    '/admin/_authed/menu': {
      id: '/admin/_authed/menu'
      path: '/menu'
      fullPath: '/admin/menu'
      preLoaderRoute: typeof AdminAuthedMenuRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
    '/admin/_authed/dashboard': {
      id: '/admin/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminAuthedDashboardRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
    '/admin/_authed/company-values': {
      id: '/admin/_authed/company-values'
      path: '/company-values'
      fullPath: '/admin/company-values'
      preLoaderRoute: typeof AdminAuthedCompanyValuesRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
    '/_public/products/$slug': {
      id: '/_public/products/$slug'
      path: '/products/$slug'
      fullPath: '/products/$slug'
      preLoaderRoute: typeof PublicProductsSlugRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/blog/$slug': {
      id: '/_public/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof PublicBlogSlugRouteImport
      parentRoute: typeof PublicRoute
    }
    '/admin/_authed/blog/': {
      id: '/admin/_authed/blog/'
      path: '/blog'
      fullPath: '/admin/blog/'
      preLoaderRoute: typeof AdminAuthedBlogIndexRouteImport
      parentRoute: typeof AdminAuthedRoute
    }
  }
}

interface PublicRouteChildren {
  PublicSlugRoute: typeof PublicSlugRoute
  PublicAboutRoute: typeof PublicAboutRoute
  PublicContactRoute: typeof PublicContactRoute
  PublicPortfolioRoute: typeof PublicPortfolioRoute
  PublicServicesRoute: typeof PublicServicesRoute
  PublicTeamRoute: typeof PublicTeamRoute
  PublicIndexRoute: typeof PublicIndexRoute
  PublicBlogSlugRoute: typeof PublicBlogSlugRoute
  PublicProductsSlugRoute: typeof PublicProductsSlugRoute
  PublicBlogIndexRoute: typeof PublicBlogIndexRoute
  PublicProductsIndexRoute: typeof PublicProductsIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicSlugRoute: PublicSlugRoute,
  PublicAboutRoute: PublicAboutRoute,
  PublicContactRoute: PublicContactRoute,
  PublicPortfolioRoute: PublicPortfolioRoute,
  PublicServicesRoute: PublicServicesRoute,
  PublicTeamRoute: PublicTeamRoute,
  PublicIndexRoute: PublicIndexRoute,
  PublicBlogSlugRoute: PublicBlogSlugRoute,
  PublicProductsSlugRoute: PublicProductsSlugRoute,
  PublicBlogIndexRoute: PublicBlogIndexRoute,
  PublicProductsIndexRoute: PublicProductsIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface AdminAuthedRouteChildren {
  AdminAuthedCompanyValuesRoute: typeof AdminAuthedCompanyValuesRoute
  AdminAuthedDashboardRoute: typeof AdminAuthedDashboardRoute
  AdminAuthedMenuRoute: typeof AdminAuthedMenuRoute
  AdminAuthedMessagesRoute: typeof AdminAuthedMessagesRoute
  AdminAuthedPagesRoute: typeof AdminAuthedPagesRoute
  AdminAuthedPortfolioRoute: typeof AdminAuthedPortfolioRoute
  AdminAuthedProductsRoute: typeof AdminAuthedProductsRoute
  AdminAuthedProfileRoute: typeof AdminAuthedProfileRoute
  AdminAuthedServicesRoute: typeof AdminAuthedServicesRoute
  AdminAuthedSettingsRoute: typeof AdminAuthedSettingsRoute
  AdminAuthedStatsRoute: typeof AdminAuthedStatsRoute
  AdminAuthedTeamRoute: typeof AdminAuthedTeamRoute
  AdminAuthedTechnologiesRoute: typeof AdminAuthedTechnologiesRoute
  AdminAuthedTestimonialsRoute: typeof AdminAuthedTestimonialsRoute
  AdminAuthedUsersRoute: typeof AdminAuthedUsersRoute
  AdminAuthedIndexRoute: typeof AdminAuthedIndexRoute
  AdminAuthedBlogIndexRoute: typeof AdminAuthedBlogIndexRoute
}

const AdminAuthedRouteChildren: AdminAuthedRouteChildren = {
  AdminAuthedCompanyValuesRoute: AdminAuthedCompanyValuesRoute,
  AdminAuthedDashboardRoute: AdminAuthedDashboardRoute,
  AdminAuthedMenuRoute: AdminAuthedMenuRoute,
  AdminAuthedMessagesRoute: AdminAuthedMessagesRoute,
  AdminAuthedPagesRoute: AdminAuthedPagesRoute,
  AdminAuthedPortfolioRoute: AdminAuthedPortfolioRoute,
  AdminAuthedProductsRoute: AdminAuthedProductsRoute,
  AdminAuthedProfileRoute: AdminAuthedProfileRoute,
  AdminAuthedServicesRoute: AdminAuthedServicesRoute,
  AdminAuthedSettingsRoute: AdminAuthedSettingsRoute,
  AdminAuthedStatsRoute: AdminAuthedStatsRoute,
  AdminAuthedTeamRoute: AdminAuthedTeamRoute,
  AdminAuthedTechnologiesRoute: AdminAuthedTechnologiesRoute,
  AdminAuthedTestimonialsRoute: AdminAuthedTestimonialsRoute,
  AdminAuthedUsersRoute: AdminAuthedUsersRoute,
  AdminAuthedIndexRoute: AdminAuthedIndexRoute,
  AdminAuthedBlogIndexRoute: AdminAuthedBlogIndexRoute,
}

const AdminAuthedRouteWithChildren = AdminAuthedRoute._addFileChildren(
  AdminAuthedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  PublicRoute: PublicRouteWithChildren,
  AdminAuthedRoute: AdminAuthedRouteWithChildren,
  AdminLoginRoute: AdminLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
